import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type AddonItemRequestType = {
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type AddonResponseType = {
  __typename?: 'AddonResponseType';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type AddonType = {
  __typename?: 'AddonType';
  _id: Scalars['String']['output'];
  group?: Maybe<Array<GroupAddonType>>;
  label: Scalars['String']['output'];
  maxChoices?: Maybe<Scalars['Int']['output']>;
  multiple: Scalars['Boolean']['output'];
};

export type CategoryType = {
  __typename?: 'CategoryType';
  active: Scalars['Boolean']['output'];
  bongUsers: Array<Scalars['String']['output']>;
  category: Scalars['Float']['output'];
  currentBongUser?: Maybe<Scalars['String']['output']>;
  deliveredOnManualPurchase: Scalars['Boolean']['output'];
  discount?: Maybe<Scalars['Int']['output']>;
  discountLimit?: Maybe<Scalars['Int']['output']>;
  inactiveIngestions?: Maybe<Array<ItemIngestionType>>;
  name: Scalars['String']['output'];
  orderFromAdmin?: Maybe<Scalars['Boolean']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  preOrderTakeaway?: Maybe<Scalars['Boolean']['output']>;
  schedule: Schedule;
  willCloseWithin?: Maybe<Scalars['Float']['output']>;
};

export type Client = {
  __typename?: 'Client';
  address?: Maybe<Scalars['String']['output']>;
  alternativeAdminPaymentMethods?: Maybe<Array<Scalars['String']['output']>>;
  categories?: Maybe<Array<CategoryType>>;
  deliveryClosed?: Maybe<Scalars['Boolean']['output']>;
  deliveryFee?: Maybe<Scalars['Int']['output']>;
  deliveryMinAmount?: Maybe<Scalars['Int']['output']>;
  deliveryTerms?: Maybe<Array<Scalars['String']['output']>>;
  displayName: Scalars['String']['output'];
  gatheredDelivery: Scalars['Boolean']['output'];
  /** @deprecated Handled by orderFromAdmin on Category */
  handlePrintReceipt?: Maybe<Scalars['Boolean']['output']>;
  hasPrinter: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  ingestions?: Maybe<Array<IngestionsType>>;
  inventoryDisplayMode: InventoryDisplayMode;
  lead: Scalars['Boolean']['output'];
  legalName: Scalars['String']['output'];
  mergedDeliveryTab?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  orgNumber: Scalars['String']['output'];
  paymentMethods: Array<Scalars['String']['output']>;
  places: Array<Scalars['String']['output']>;
  preventReloadWhenConnectionRegained?: Maybe<Scalars['Boolean']['output']>;
  preventTip?: Maybe<Scalars['Boolean']['output']>;
  receiptDevices?: Maybe<Array<Scalars['String']['output']>>;
  registerId?: Maybe<Scalars['String']['output']>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  sumUpConfig?: Maybe<SumUpConfig>;
  testMode: Scalars['Boolean']['output'];
  workingBatchInHours?: Maybe<Scalars['Float']['output']>;
  zReportRecipients: Array<Scalars['String']['output']>;
};

export type CreateOrderFail = {
  __typename?: 'CreateOrderFail';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  inactiveCategories: Array<Scalars['Float']['output']>;
  incorrectItems: Array<IncorrectItemType>;
  missingItems: Array<Scalars['String']['output']>;
};

export type CreateOrderInput = {
  billId?: InputMaybe<Scalars['String']['input']>;
  billName?: InputMaybe<Scalars['String']['input']>;
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  client: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<InputDeliveryAddress>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  ingestion: ItemIngestionType;
  items: Array<ItemRequestType>;
  /** The mobile phone from the user */
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderType: OrderType;
  paymentTransactionId?: InputMaybe<Scalars['String']['input']>;
  paymentType: OrderItemPaymentType;
  pickupTime?: InputMaybe<Scalars['String']['input']>;
  printReceipt?: InputMaybe<PrintReceiptInputType>;
  receiptEmailAddress?: InputMaybe<Scalars['String']['input']>;
  returnForOrder?: InputMaybe<Scalars['ID']['input']>;
  smsReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  /** The table number from the user */
  tableNumber?: InputMaybe<Scalars['String']['input']>;
  tip?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOrderResponse = CreateOrderFail | CreateOrderSuccess;

export type CreateOrderSuccess = {
  __typename?: 'CreateOrderSuccess';
  details: CreateOrderSuccessDetails;
  id: Scalars['String']['output'];
};

export type CreateOrderSuccessDetails = StripeSuccessDetails | SwbPayCreditcardSuccessDetails | SwbPaySwishSuccessDetails | SwishSuccessDetails;

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  city: Scalars['String']['output'];
  name: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['Int']['output'];
};

export type Discount = {
  __typename?: 'Discount';
  categories: Array<DiscountCategory>;
  code: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type DiscountCategory = {
  __typename?: 'DiscountCategory';
  category: Scalars['Int']['output'];
  discount: Scalars['Int']['output'];
};

export type ExceptionTime = {
  __typename?: 'ExceptionTime';
  date: Scalars['String']['output'];
  times?: Maybe<Array<ScheduleTime>>;
};

export type GroupAddonRequestType = {
  addonItems: Array<AddonItemRequestType>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type GroupAddonResponseType = {
  __typename?: 'GroupAddonResponseType';
  addonItems: Array<AddonResponseType>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type GroupAddonType = {
  __typename?: 'GroupAddonType';
  _id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type HistoricOrder = {
  __typename?: 'HistoricOrder';
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  receipt: Scalars['String']['output'];
  responseAt: Scalars['Float']['output'];
};

export type IncorrectItemType = {
  __typename?: 'IncorrectItemType';
  diffingPrice?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

export type IngestionType = {
  __typename?: 'IngestionType';
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<ItemIngestionType>;
};

export type IngestionsType = {
  __typename?: 'IngestionsType';
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  checkoutMessageWithHomeDelivery?: Maybe<Scalars['String']['output']>;
  checkoutMessageWithMinutesUntilDelivery?: Maybe<Scalars['String']['output']>;
  discounts: Array<Discount>;
  infoHomeDelivery?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  minutesUntilDelivery?: Maybe<Scalars['Float']['output']>;
  orderConfirmMessage?: Maybe<Scalars['String']['output']>;
  orderConfirmMessagePreOrder?: Maybe<Scalars['String']['output']>;
  orderConfirmMessageWithMinutesUntilDelivery?: Maybe<Scalars['String']['output']>;
  receiptMessageWithHomeDelivery?: Maybe<Scalars['String']['output']>;
  receiptMessageWithHomeDeliveryPreOrder?: Maybe<Scalars['String']['output']>;
  type: ItemIngestionType;
};

export type InputDeliveryAddress = {
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['Int']['input'];
};

export enum InventoryDisplayMode {
  Gallery = 'GALLERY',
  List = 'LIST'
}

export type Item = {
  __typename?: 'Item';
  addons?: Maybe<Array<AddonType>>;
  category?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  info?: Maybe<Scalars['String']['output']>;
  ingestions: Array<IngestionType>;
  itemCategory: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Float']['output'];
  stock?: Maybe<Scalars['Float']['output']>;
  vatCategory?: Maybe<Scalars['Float']['output']>;
};

export type ItemCategory = {
  __typename?: 'ItemCategory';
  category: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
};

export type ItemIngestionInput = {
  price: Scalars['Float']['input'];
  type: ItemIngestionType;
};

export enum ItemIngestionType {
  InHouse = 'IN_HOUSE',
  Takeaway = 'TAKEAWAY'
}

export type ItemRequestType = {
  addonGroups: Array<Array<GroupAddonRequestType>>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<OrderItemStatusType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addScheduleException: Scalars['Boolean']['output'];
  cancelPayment?: Maybe<Scalars['Boolean']['output']>;
  claimBongPrinter?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Unused since app-version 1.11.0 */
  claimOrderReceiptPrinter?: Maybe<Scalars['Boolean']['output']>;
  claimPrintCategories?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Unused since app-version 1.11.0 */
  claimPrinterForCategories?: Maybe<Scalars['Boolean']['output']>;
  closeDelivery?: Maybe<Scalars['Boolean']['output']>;
  contact: Scalars['Boolean']['output'];
  createOrder: CreateOrderResponse;
  deleteItem?: Maybe<Scalars['Boolean']['output']>;
  emailReceipt?: Maybe<Scalars['Boolean']['output']>;
  openDelivery?: Maybe<Scalars['Boolean']['output']>;
  removeScheduleException: Scalars['Boolean']['output'];
  requestXReport?: Maybe<Scalars['Boolean']['output']>;
  requestZReport?: Maybe<Scalars['Boolean']['output']>;
  retryPayment?: Maybe<OrderAddResponseType>;
  saveItem?: Maybe<Item>;
  sortItem?: Maybe<Scalars['Boolean']['output']>;
  updateActiveIngestion?: Maybe<Scalars['Boolean']['output']>;
  updateIngestion?: Maybe<Scalars['Boolean']['output']>;
  updateItem?: Maybe<Scalars['Boolean']['output']>;
  updateOrderItems?: Maybe<Scalars['Boolean']['output']>;
  updateOrderReceiptPrintStatus?: Maybe<OrderPrintStatusResponseType>;
  /** @deprecated Unused since app-version 1.11.0 */
  updatePrintStatus?: Maybe<OrderPrintStatusResponseType>;
};


export type MutationAddScheduleExceptionArgs = {
  category: Scalars['Int']['input'];
  closedAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['Date']['input'];
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
};


export type MutationCancelPaymentArgs = {
  orderId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationClaimBongPrinterArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  claim?: InputMaybe<Scalars['Boolean']['input']>;
  client: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClaimOrderReceiptPrinterArgs = {
  claim?: InputMaybe<Scalars['Boolean']['input']>;
  clientId: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
};


export type MutationClaimPrintCategoriesArgs = {
  categoryIds: Array<Scalars['Int']['input']>;
  claim: Scalars['Boolean']['input'];
  deviceId: Scalars['String']['input'];
};


export type MutationClaimPrinterForCategoriesArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  claim?: InputMaybe<Scalars['Boolean']['input']>;
  client: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationContactArgs = {
  deviceId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationDeleteItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEmailReceiptArgs = {
  clientId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  recipient: Scalars['String']['input'];
};


export type MutationRemoveScheduleExceptionArgs = {
  category: Scalars['Int']['input'];
  date: Scalars['Date']['input'];
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
};


export type MutationRequestXReportArgs = {
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRequestZReportArgs = {
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRetryPaymentArgs = {
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  swishTrack: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveItemArgs = {
  client: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  ingestions?: InputMaybe<Array<InputMaybe<ItemIngestionInput>>>;
  itemCategory: Scalars['String']['input'];
  name: Scalars['String']['input'];
  outOfStock: Scalars['Boolean']['input'];
  preview?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Float']['input']>;
  vatCategory: Scalars['Float']['input'];
};


export type MutationSortItemArgs = {
  client?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateActiveIngestionArgs = {
  active: Scalars['Boolean']['input'];
  category: Scalars['Float']['input'];
  clientId: Scalars['String']['input'];
  ingestion: ItemIngestionType;
};


export type MutationUpdateIngestionArgs = {
  clientId: Scalars['String']['input'];
  ingestion: ItemIngestionType;
  minutesUntilDelivery?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateItemArgs = {
  clientId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  stock?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateOrderItemsArgs = {
  clientId: Scalars['String']['input'];
  deliveryTerm?: InputMaybe<OrderItemDeliveryTermType>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  status: OrderItemStatusType;
};


export type MutationUpdateOrderReceiptPrintStatusArgs = {
  deviceName: Scalars['String']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  printStatus: OrderPrintStatus;
};


export type MutationUpdatePrintStatusArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  printErrorMessage?: InputMaybe<Scalars['String']['input']>;
  printStatus: OrderPrintStatus;
};

export type OrderAddResponseType = {
  __typename?: 'OrderAddResponseType';
  fail?: Maybe<OrderFailResponseType>;
  success?: Maybe<OrderSuccessResponseType>;
};

export type OrderFailResponseType = {
  __typename?: 'OrderFailResponseType';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  inactiveCategories?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  incorrectItems?: Maybe<Array<Maybe<IncorrectItemType>>>;
  missingItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum OrderItemDeliveryTermType {
  Collect = 'COLLECT',
  Deliver = 'DELIVER'
}

export enum OrderItemPaymentType {
  Cash = 'CASH',
  Creditcard = 'CREDITCARD',
  Invoice = 'INVOICE',
  OpenBill = 'OPEN_BILL',
  Other = 'OTHER',
  SwbCreditcard = 'SWB_CREDITCARD',
  SwbSwish = 'SWB_SWISH',
  Swish = 'SWISH',
  SwishBusiness = 'SWISH_BUSINESS'
}

export type OrderItemResponseType = {
  __typename?: 'OrderItemResponseType';
  _id?: Maybe<Scalars['String']['output']>;
  addonGroups?: Maybe<Array<Array<GroupAddonResponseType>>>;
  amount?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  copies?: Maybe<Scalars['Int']['output']>;
  deliveredAt?: Maybe<Scalars['Float']['output']>;
  deliveryTerm?: Maybe<Scalars['String']['output']>;
  isProcessing?: Maybe<Scalars['Boolean']['output']>;
  itemCategory?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  printErrorMessage?: Maybe<Scalars['String']['output']>;
  printStatus?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vatCategory?: Maybe<Scalars['Float']['output']>;
  vatCode?: Maybe<Scalars['Float']['output']>;
};

export enum OrderItemStatusType {
  Delivered = 'DELIVERED',
  Unprocessed = 'UNPROCESSED'
}

export type OrderItemsResponseType = {
  __typename?: 'OrderItemsResponseType';
  createdAt?: Maybe<Scalars['Float']['output']>;
  deliveryAddress?: Maybe<DeliveryAddress>;
  errorCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ingestion?: Maybe<ItemIngestionType>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderItems?: Maybe<OrderItemResponseType>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  pickupTime?: Maybe<Scalars['String']['output']>;
  responseAt?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tableNumber?: Maybe<Scalars['String']['output']>;
};

export enum OrderPrintStatus {
  Error = 'ERROR',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Unprocessed = 'UNPROCESSED'
}

export type OrderPrintStatusResponseType = {
  __typename?: 'OrderPrintStatusResponseType';
  ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OrderSuccessResponseType = {
  __typename?: 'OrderSuccessResponseType';
  id?: Maybe<Scalars['String']['output']>;
  stripe?: Maybe<Stripe>;
  swedbank?: Maybe<Swedbank>;
  swish?: Maybe<Swish>;
};

export enum OrderType {
  Order = 'ORDER',
  Return = 'RETURN'
}

export type PrintReceiptInputType = {
  deviceName?: InputMaybe<Scalars['String']['input']>;
  printOrderReceipt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  client: Client;
  clients?: Maybe<Array<Client>>;
  itemCategories?: Maybe<Array<ItemCategory>>;
  items?: Maybe<Array<Item>>;
  login: User;
  logout: Scalars['Boolean']['output'];
  order?: Maybe<Array<OrderItemsResponseType>>;
  orderHistory: Array<HistoricOrder>;
  orderItems?: Maybe<Array<OrderItemsResponseType>>;
  orderReceipt: Scalars['String']['output'];
  sales?: Maybe<Array<SalesType>>;
  stripeConfig: StripeConfig;
  user: User;
};


export type QueryClientArgs = {
  client: Scalars['String']['input'];
  ingestion: ItemIngestionType;
};


export type QueryClientsArgs = {
  ingestion: ItemIngestionType;
};


export type QueryItemCategoriesArgs = {
  category?: InputMaybe<Scalars['Float']['input']>;
  clientId: Scalars['String']['input'];
};


export type QueryItemsArgs = {
  category?: InputMaybe<Scalars['Float']['input']>;
  clientId: Scalars['String']['input'];
};


export type QueryLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type QueryOrderArgs = {
  lastToken: Scalars['String']['input'];
};


export type QueryOrderHistoryArgs = {
  deviceId: Scalars['String']['input'];
};


export type QueryOrderItemsArgs = {
  category?: InputMaybe<Array<Scalars['Float']['input']>>;
  clientId: Scalars['String']['input'];
  status?: InputMaybe<Array<OrderItemStatusType>>;
};


export type QueryOrderReceiptArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  idOrToken: Scalars['String']['input'];
};


export type QuerySalesArgs = {
  client: Scalars['String']['input'];
  fromHoursBack?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesIngestionType = {
  __typename?: 'SalesIngestionType';
  totalSumExclTip?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SalesType = {
  __typename?: 'SalesType';
  ingestions?: Maybe<Array<Maybe<SalesIngestionType>>>;
  totalTip?: Maybe<Scalars['Float']['output']>;
  transactionsCount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Schedule = {
  __typename?: 'Schedule';
  FRIDAY?: Maybe<Array<ScheduleTime>>;
  MONDAY?: Maybe<Array<ScheduleTime>>;
  SATURDAY?: Maybe<Array<ScheduleTime>>;
  SUNDAY?: Maybe<Array<ScheduleTime>>;
  THURSDAY?: Maybe<Array<ScheduleTime>>;
  TUESDAY?: Maybe<Array<ScheduleTime>>;
  WEDNESDAY?: Maybe<Array<ScheduleTime>>;
  exceptions: Array<ExceptionTime>;
};

export type ScheduleTime = {
  __typename?: 'ScheduleTime';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type StripeConfig = {
  __typename?: 'StripeConfig';
  publicKey: Scalars['String']['output'];
};

export type StripeSuccessDetails = {
  __typename?: 'StripeSuccessDetails';
  cancel: Scalars['String']['output'];
  session: Scalars['String']['output'];
  success: Scalars['String']['output'];
};

export type SumUpConfig = {
  __typename?: 'SumUpConfig';
  affiliateKey: Scalars['String']['output'];
};

export type SwbPayCreditcardSuccessDetails = {
  __typename?: 'SwbPayCreditcardSuccessDetails';
  id: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
};

export type SwbPaySwishSuccessDetails = {
  __typename?: 'SwbPaySwishSuccessDetails';
  id: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type SwishSuccessDetails = {
  __typename?: 'SwishSuccessDetails';
  paymentRequestToken?: Maybe<Scalars['String']['output']>;
  swishTrack?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  client?: Maybe<Client>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Stripe = {
  __typename?: 'stripe';
  cancel: Scalars['String']['output'];
  session: Scalars['String']['output'];
  success: Scalars['String']['output'];
};

export type Swedbank = {
  __typename?: 'swedbank';
  id: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type Swish = {
  __typename?: 'swish';
  paymentRequestToken?: Maybe<Scalars['String']['output']>;
  swishTrack?: Maybe<Scalars['String']['output']>;
};

export type CancelPaymentMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type CancelPaymentMutation = { __typename?: 'Mutation', cancelPayment?: boolean | null };

export type ContactMutationVariables = Exact<{
  email: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
}>;


export type ContactMutation = { __typename?: 'Mutation', contact: boolean };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename: 'CreateOrderFail', errorCode?: string | null, errorMessage?: string | null, inactiveCategories: Array<number>, incorrectItems: Array<{ __typename?: 'IncorrectItemType', id?: string | null, outOfStock?: boolean | null, diffingPrice?: boolean | null, stock?: number | null }> } | { __typename: 'CreateOrderSuccess', id: string, details: { __typename?: 'StripeSuccessDetails' } | { __typename: 'SwbPayCreditcardSuccessDetails', id: string, creditCardUrl: string } | { __typename: 'SwbPaySwishSuccessDetails', id: string, redirectUrl?: string | null } | { __typename?: 'SwishSuccessDetails' } } };

export type EmailReceiptMutationVariables = Exact<{
  clientId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  recipient: Scalars['String']['input'];
}>;


export type EmailReceiptMutation = { __typename?: 'Mutation', emailReceipt?: boolean | null };

export type RetrySwishPaymentMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  token: Scalars['String']['input'];
  swishTrack: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type RetrySwishPaymentMutation = { __typename?: 'Mutation', retryPayment?: { __typename?: 'OrderAddResponseType', success?: { __typename?: 'OrderSuccessResponseType', id?: string | null, swish?: { __typename?: 'swish', swishTrack?: string | null } | null, swedbank?: { __typename?: 'swedbank', id: string } | null } | null, fail?: { __typename?: 'OrderFailResponseType', errorCode?: string | null, errorMessage?: string | null, inactiveCategories?: Array<number | null> | null } | null } | null };

export type ClientQueryVariables = Exact<{
  ingestion: ItemIngestionType;
  client: Scalars['String']['input'];
}>;


export type ClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, name: string, orgNumber: string, legalName: string, displayName: string, deliveryTerms?: Array<string> | null, preventTip?: boolean | null, paymentMethods: Array<string>, stripePublishableKey?: string | null, deliveryClosed?: boolean | null, deliveryMinAmount?: number | null, deliveryFee?: number | null, testMode: boolean, gatheredDelivery: boolean, hasPrinter: boolean, inventoryDisplayMode: InventoryDisplayMode, lead: boolean, zReportRecipients: Array<string>, places: Array<string>, ingestions?: Array<{ __typename?: 'IngestionsType', type: ItemIngestionType, logo?: string | null, minutesUntilDelivery?: number | null, infoHomeDelivery?: string | null, checkoutMessage?: string | null, checkoutMessageWithMinutesUntilDelivery?: string | null, checkoutMessageWithHomeDelivery?: string | null, receiptMessageWithHomeDelivery?: string | null, receiptMessageWithHomeDeliveryPreOrder?: string | null, orderConfirmMessage?: string | null, orderConfirmMessagePreOrder?: string | null, orderConfirmMessageWithMinutesUntilDelivery?: string | null, discounts: Array<{ __typename?: 'Discount', code: string, from?: string | null, to?: string | null, categories: Array<{ __typename?: 'DiscountCategory', category: number, discount: number }> }> }> | null, categories?: Array<{ __typename?: 'CategoryType', category: number, bongUsers: Array<string>, deliveredOnManualPurchase: boolean, name: string, place?: string | null, active: boolean, inactiveIngestions?: Array<ItemIngestionType> | null, willCloseWithin?: number | null, preOrderTakeaway?: boolean | null, discountLimit?: number | null, discount?: number | null, schedule: { __typename?: 'Schedule', exceptions: Array<{ __typename?: 'ExceptionTime', date: string, times?: Array<{ __typename?: 'ScheduleTime', from: string, to: string }> | null }>, MONDAY?: Array<{ __typename?: 'ScheduleTime', from: string, to: string }> | null, TUESDAY?: Array<{ __typename?: 'ScheduleTime', from: string, to: string }> | null, WEDNESDAY?: Array<{ __typename?: 'ScheduleTime', from: string, to: string }> | null, THURSDAY?: Array<{ __typename?: 'ScheduleTime', from: string, to: string }> | null, FRIDAY?: Array<{ __typename?: 'ScheduleTime', from: string, to: string }> | null, SATURDAY?: Array<{ __typename?: 'ScheduleTime', from: string, to: string }> | null, SUNDAY?: Array<{ __typename?: 'ScheduleTime', from: string, to: string }> | null } }> | null } };

export type AllClientsQueryVariables = Exact<{
  ingestion: ItemIngestionType;
}>;


export type AllClientsQuery = { __typename?: 'Query', clients?: Array<{ __typename?: 'Client', id: string, displayName: string, name: string, testMode: boolean, ingestions?: Array<{ __typename?: 'IngestionsType', logo?: string | null, type: ItemIngestionType }> | null }> | null };

export type OrderHistoryQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type OrderHistoryQuery = { __typename?: 'Query', orderHistory: Array<{ __typename?: 'HistoricOrder', id: string, clientId: string, clientName: string, responseAt: number, receipt: string }> };

export type ItemsQueryVariables = Exact<{
  client: Scalars['String']['input'];
  category?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ItemsQuery = { __typename?: 'Query', itemCategories?: Array<{ __typename?: 'ItemCategory', id: string, name: string, preview?: string | null, description?: string | null, category: number, sortOrder: number }> | null, items?: Array<{ __typename?: 'Item', id: string, name: string, preview?: string | null, info?: string | null, description?: string | null, outOfStock?: boolean | null, sortOrder: number, category?: number | null, vatCategory?: number | null, itemCategory: string, ingestions: Array<{ __typename?: 'IngestionType', price?: number | null, type?: ItemIngestionType | null }>, addons?: Array<{ __typename?: 'AddonType', _id: string, label: string, multiple: boolean, maxChoices?: number | null, group?: Array<{ __typename?: 'GroupAddonType', _id: string, label: string, price: number }> | null }> | null }> | null };

export type OrderQueryVariables = Exact<{
  lastToken: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', orderReceipt: string, order?: Array<{ __typename?: 'OrderItemsResponseType', id?: string | null, status?: string | null, responseAt?: number | null, createdAt?: number | null, errorCode?: string | null, tableNumber?: string | null, mobilePhone?: string | null, orderNumber?: string | null, ingestion?: ItemIngestionType | null, note?: string | null, pickupTime?: string | null, deliveryAddress?: { __typename?: 'DeliveryAddress', name: string, street: string, zipCode: number, city: string } | null, orderItems?: { __typename?: 'OrderItemResponseType', name?: string | null, price?: number | null, comment?: string | null, amount?: number | null, type?: string | null, status?: string | null, isProcessing?: boolean | null, deliveryTerm?: string | null, category?: number | null, deliveredAt?: number | null, itemCategory?: string | null, addonGroups?: Array<Array<{ __typename?: 'GroupAddonResponseType', addonItems: Array<{ __typename?: 'AddonResponseType', label?: string | null, price?: number | null }> }>> | null } | null }> | null };


export const CancelPaymentDocument = gql`
    mutation CancelPayment($orderId: String!, $token: String!) {
  cancelPayment(orderId: $orderId, token: $token)
}
    `;
export type CancelPaymentMutationFn = Apollo.MutationFunction<CancelPaymentMutation, CancelPaymentMutationVariables>;

/**
 * __useCancelPaymentMutation__
 *
 * To run a mutation, you first call `useCancelPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentMutation, { data, loading, error }] = useCancelPaymentMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCancelPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CancelPaymentMutation, CancelPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPaymentMutation, CancelPaymentMutationVariables>(CancelPaymentDocument, options);
      }
export type CancelPaymentMutationHookResult = ReturnType<typeof useCancelPaymentMutation>;
export type CancelPaymentMutationResult = Apollo.MutationResult<CancelPaymentMutation>;
export type CancelPaymentMutationOptions = Apollo.BaseMutationOptions<CancelPaymentMutation, CancelPaymentMutationVariables>;
export const ContactDocument = gql`
    mutation Contact($email: String!, $deviceId: String!) {
  contact(email: $email, deviceId: $deviceId)
}
    `;
export type ContactMutationFn = Apollo.MutationFunction<ContactMutation, ContactMutationVariables>;

/**
 * __useContactMutation__
 *
 * To run a mutation, you first call `useContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactMutation, { data, loading, error }] = useContactMutation({
 *   variables: {
 *      email: // value for 'email'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useContactMutation(baseOptions?: Apollo.MutationHookOptions<ContactMutation, ContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactMutation, ContactMutationVariables>(ContactDocument, options);
      }
export type ContactMutationHookResult = ReturnType<typeof useContactMutation>;
export type ContactMutationResult = Apollo.MutationResult<ContactMutation>;
export type ContactMutationOptions = Apollo.BaseMutationOptions<ContactMutation, ContactMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    ... on CreateOrderFail {
      __typename
      errorCode
      errorMessage
      inactiveCategories
      incorrectItems {
        id
        outOfStock
        diffingPrice
        stock
      }
    }
    ... on CreateOrderSuccess {
      __typename
      id
      details {
        ... on SwbPaySwishSuccessDetails {
          __typename
          id
          redirectUrl
        }
        ... on SwbPayCreditcardSuccessDetails {
          __typename
          id
          creditCardUrl: redirectUrl
        }
      }
    }
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const EmailReceiptDocument = gql`
    mutation EmailReceipt($clientId: String!, $orderId: String!, $recipient: String!) {
  emailReceipt(clientId: $clientId, orderId: $orderId, recipient: $recipient)
}
    `;
export type EmailReceiptMutationFn = Apollo.MutationFunction<EmailReceiptMutation, EmailReceiptMutationVariables>;

/**
 * __useEmailReceiptMutation__
 *
 * To run a mutation, you first call `useEmailReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailReceiptMutation, { data, loading, error }] = useEmailReceiptMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      orderId: // value for 'orderId'
 *      recipient: // value for 'recipient'
 *   },
 * });
 */
export function useEmailReceiptMutation(baseOptions?: Apollo.MutationHookOptions<EmailReceiptMutation, EmailReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailReceiptMutation, EmailReceiptMutationVariables>(EmailReceiptDocument, options);
      }
export type EmailReceiptMutationHookResult = ReturnType<typeof useEmailReceiptMutation>;
export type EmailReceiptMutationResult = Apollo.MutationResult<EmailReceiptMutation>;
export type EmailReceiptMutationOptions = Apollo.BaseMutationOptions<EmailReceiptMutation, EmailReceiptMutationVariables>;
export const RetrySwishPaymentDocument = gql`
    mutation RetrySwishPayment($orderId: String!, $token: String!, $swishTrack: String!, $phoneNumber: String!) {
  retryPayment(
    orderId: $orderId
    token: $token
    swishTrack: $swishTrack
    mobilePhone: $phoneNumber
  ) {
    success {
      id
      swish {
        swishTrack
      }
      swedbank {
        id
      }
    }
    fail {
      errorCode
      errorMessage
      inactiveCategories
    }
  }
}
    `;
export type RetrySwishPaymentMutationFn = Apollo.MutationFunction<RetrySwishPaymentMutation, RetrySwishPaymentMutationVariables>;

/**
 * __useRetrySwishPaymentMutation__
 *
 * To run a mutation, you first call `useRetrySwishPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySwishPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySwishPaymentMutation, { data, loading, error }] = useRetrySwishPaymentMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      token: // value for 'token'
 *      swishTrack: // value for 'swishTrack'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useRetrySwishPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RetrySwishPaymentMutation, RetrySwishPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySwishPaymentMutation, RetrySwishPaymentMutationVariables>(RetrySwishPaymentDocument, options);
      }
export type RetrySwishPaymentMutationHookResult = ReturnType<typeof useRetrySwishPaymentMutation>;
export type RetrySwishPaymentMutationResult = Apollo.MutationResult<RetrySwishPaymentMutation>;
export type RetrySwishPaymentMutationOptions = Apollo.BaseMutationOptions<RetrySwishPaymentMutation, RetrySwishPaymentMutationVariables>;
export const ClientDocument = gql`
    query Client($ingestion: ItemIngestionType!, $client: String!) {
  client(ingestion: $ingestion, client: $client) {
    id
    name
    orgNumber
    legalName
    displayName
    deliveryTerms
    preventTip
    paymentMethods
    stripePublishableKey
    deliveryClosed
    deliveryMinAmount
    deliveryFee
    testMode
    gatheredDelivery
    hasPrinter
    inventoryDisplayMode
    lead
    zReportRecipients
    places
    ingestions {
      type
      logo
      minutesUntilDelivery
      infoHomeDelivery
      checkoutMessage
      checkoutMessageWithMinutesUntilDelivery
      checkoutMessageWithHomeDelivery
      receiptMessageWithHomeDelivery
      receiptMessageWithHomeDeliveryPreOrder
      orderConfirmMessage
      orderConfirmMessagePreOrder
      orderConfirmMessageWithMinutesUntilDelivery
      discounts {
        code
        categories {
          category
          discount
        }
        from
        to
      }
    }
    categories {
      category
      bongUsers
      deliveredOnManualPurchase
      name
      place
      active
      inactiveIngestions
      willCloseWithin
      preOrderTakeaway
      discountLimit
      discount
      schedule {
        exceptions {
          date
          times {
            from
            to
          }
        }
        MONDAY {
          from
          to
        }
        TUESDAY {
          from
          to
        }
        WEDNESDAY {
          from
          to
        }
        THURSDAY {
          from
          to
        }
        FRIDAY {
          from
          to
        }
        SATURDAY {
          from
          to
        }
        SUNDAY {
          from
          to
        }
      }
    }
  }
}
    `;

/**
 * __useClientQuery__
 *
 * To run a query within a React component, call `useClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuery({
 *   variables: {
 *      ingestion: // value for 'ingestion'
 *      client: // value for 'client'
 *   },
 * });
 */
export function useClientQuery(baseOptions: Apollo.QueryHookOptions<ClientQuery, ClientQueryVariables> & ({ variables: ClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
      }
export function useClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
        }
export function useClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
        }
export type ClientQueryHookResult = ReturnType<typeof useClientQuery>;
export type ClientLazyQueryHookResult = ReturnType<typeof useClientLazyQuery>;
export type ClientSuspenseQueryHookResult = ReturnType<typeof useClientSuspenseQuery>;
export type ClientQueryResult = Apollo.QueryResult<ClientQuery, ClientQueryVariables>;
export const AllClientsDocument = gql`
    query AllClients($ingestion: ItemIngestionType!) {
  clients(ingestion: $ingestion) {
    id
    displayName
    name
    testMode
    ingestions {
      logo
      type
    }
  }
}
    `;

/**
 * __useAllClientsQuery__
 *
 * To run a query within a React component, call `useAllClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllClientsQuery({
 *   variables: {
 *      ingestion: // value for 'ingestion'
 *   },
 * });
 */
export function useAllClientsQuery(baseOptions: Apollo.QueryHookOptions<AllClientsQuery, AllClientsQueryVariables> & ({ variables: AllClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllClientsQuery, AllClientsQueryVariables>(AllClientsDocument, options);
      }
export function useAllClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllClientsQuery, AllClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllClientsQuery, AllClientsQueryVariables>(AllClientsDocument, options);
        }
export function useAllClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllClientsQuery, AllClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllClientsQuery, AllClientsQueryVariables>(AllClientsDocument, options);
        }
export type AllClientsQueryHookResult = ReturnType<typeof useAllClientsQuery>;
export type AllClientsLazyQueryHookResult = ReturnType<typeof useAllClientsLazyQuery>;
export type AllClientsSuspenseQueryHookResult = ReturnType<typeof useAllClientsSuspenseQuery>;
export type AllClientsQueryResult = Apollo.QueryResult<AllClientsQuery, AllClientsQueryVariables>;
export const OrderHistoryDocument = gql`
    query OrderHistory($deviceId: String!) {
  orderHistory(deviceId: $deviceId) {
    id
    clientId
    clientName
    responseAt
    receipt
  }
}
    `;

/**
 * __useOrderHistoryQuery__
 *
 * To run a query within a React component, call `useOrderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderHistoryQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useOrderHistoryQuery(baseOptions: Apollo.QueryHookOptions<OrderHistoryQuery, OrderHistoryQueryVariables> & ({ variables: OrderHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderHistoryQuery, OrderHistoryQueryVariables>(OrderHistoryDocument, options);
      }
export function useOrderHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderHistoryQuery, OrderHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderHistoryQuery, OrderHistoryQueryVariables>(OrderHistoryDocument, options);
        }
export function useOrderHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderHistoryQuery, OrderHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderHistoryQuery, OrderHistoryQueryVariables>(OrderHistoryDocument, options);
        }
export type OrderHistoryQueryHookResult = ReturnType<typeof useOrderHistoryQuery>;
export type OrderHistoryLazyQueryHookResult = ReturnType<typeof useOrderHistoryLazyQuery>;
export type OrderHistorySuspenseQueryHookResult = ReturnType<typeof useOrderHistorySuspenseQuery>;
export type OrderHistoryQueryResult = Apollo.QueryResult<OrderHistoryQuery, OrderHistoryQueryVariables>;
export const ItemsDocument = gql`
    query Items($client: String!, $category: Float) {
  itemCategories(clientId: $client, category: $category) {
    id
    name
    preview
    description
    category
    sortOrder
  }
  items(clientId: $client, category: $category) {
    id
    name
    preview
    info
    description
    outOfStock
    sortOrder
    category
    vatCategory
    ingestions {
      price
      type
    }
    itemCategory
    addons {
      _id
      label
      multiple
      maxChoices
      group {
        _id
        label
        price
      }
    }
  }
}
    `;

/**
 * __useItemsQuery__
 *
 * To run a query within a React component, call `useItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsQuery({
 *   variables: {
 *      client: // value for 'client'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useItemsQuery(baseOptions: Apollo.QueryHookOptions<ItemsQuery, ItemsQueryVariables> & ({ variables: ItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
      }
export function useItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
        }
export function useItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
        }
export type ItemsQueryHookResult = ReturnType<typeof useItemsQuery>;
export type ItemsLazyQueryHookResult = ReturnType<typeof useItemsLazyQuery>;
export type ItemsSuspenseQueryHookResult = ReturnType<typeof useItemsSuspenseQuery>;
export type ItemsQueryResult = Apollo.QueryResult<ItemsQuery, ItemsQueryVariables>;
export const OrderDocument = gql`
    query Order($lastToken: String!, $clientId: String!) {
  order(lastToken: $lastToken) {
    id
    status
    responseAt
    createdAt
    errorCode
    tableNumber
    mobilePhone
    orderNumber
    ingestion
    note
    pickupTime
    deliveryAddress {
      name
      street
      zipCode
      city
    }
    orderItems {
      name
      price
      comment
      amount
      type
      status
      isProcessing
      deliveryTerm
      category
      deliveredAt
      itemCategory
      addonGroups {
        addonItems {
          label
          price
        }
      }
    }
  }
  orderReceipt(idOrToken: $lastToken, clientId: $clientId)
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      lastToken: // value for 'lastToken'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables> & ({ variables: OrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export function useOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderSuspenseQueryHookResult = ReturnType<typeof useOrderSuspenseQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;